import React, {Fragment, useEffect} from "react"
import {useDispatch} from "react-redux"
// UI
import {Alert} from "@uprise/alert"
// Slices
import {clearUpdateSessionsApiState} from "./sessionSlice"

export const Alerts = ({updateSessionsApiState}) => {
	const dispatch = useDispatch()

	useEffect(() => {
		if (updateSessionsApiState.isError || updateSessionsApiState.isSuccess) {
			setTimeout(() => {
				dispatch(clearUpdateSessionsApiState())
			}, 3000)
		}
	}, [updateSessionsApiState])

	return (
		<Fragment>
			{updateSessionsApiState.isError && (
				<Alert className='m-b-5' type='error'>
					{updateSessionsApiState.message}
				</Alert>
			)}
			{updateSessionsApiState.isSuccess && (
				<Alert className='m-b-5' type='success'>
					{updateSessionsApiState.message}
				</Alert>
			)}
		</Fragment>
	)
}
